// Check distance from top of the page and add sticky class to the collection toolbar with header and prods counter (opacity 0 to 1, and change height) => main-collection [on scroll]
document.addEventListener("DOMContentLoaded", function () {
    const toolbar = document.querySelector(".collection-toolbar");
    const target = document.querySelector(".collection-banner__desc-wrap");

    if (!toolbar || !target) return;

    const observer = new IntersectionObserver(
        (entries) => {
            const [entry] = entries;
            toolbar.classList.toggle("sticky-toolbar", !entry.isIntersecting);
        },
        { root: null, threshold: 0 }
    );

    observer.observe(target);
});